import { useEffect } from "react";
import { PageContent, useGetAllParams } from "./comp";
import { sendBaikePV } from "../../utils/mping";

export default () => {
  const paramsInfo = useGetAllParams(["hospitalId", "diseaseId"]);
  const {
    selectedProvince,
    cityId,
    diseaseId,
    provinceId,
    hospitalId,
    departmentId,
    secondDepartId,
    departmentCode,
  } = paramsInfo;

  useEffect(() => {
    // 医院疾病页
    sendBaikePV("InternetHospital_Hospitaldiseases");
  }, []);

  return <PageContent paramsInfo={paramsInfo} />;
};
